import { createApi } from "@reduxjs/toolkit/query/react";

import { IGetRelaxationReportsResponse } from "../../types/relaxationReport";
import { baseQueryWithIntercept } from "../connection/api";

const ENDPOINT_PREFIX = "relaxationReports";

export const relaxationReportsApi = createApi({
    reducerPath: "relaxationReportsApi",
    baseQuery: baseQueryWithIntercept,
    tagTypes: ["relaxationReport"],
    endpoints: build => ({
        getRelaxationReports: build.query<IGetRelaxationReportsResponse, void>({
            query: () => ({
                url: `${ENDPOINT_PREFIX}/anonymous`,
            }),
            providesTags: ["relaxationReport"],
        }),
    }),
});

export const {
    useGetRelaxationReportsQuery,
} = relaxationReportsApi;
